import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Users, 
  Link2, 
  Phone, 
  LogOut,
  CheckCircle,
  LayoutDashboard,
  FileText,
  ClipboardList,
  FileCheck
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const OpsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    // Check if logged in
    const token = localStorage.getItem('ops_token');
    const emp = localStorage.getItem('ops_employee');
    
    if (!token || !emp) {
      navigate('/ops/login');
      return;
    }
    
    setEmployee(JSON.parse(emp));
  }, [navigate]);

  const handleLogout = async () => {
    const token = localStorage.getItem('ops_token');
    
    try {
      await fetch(`${API_URL}/api/ops/logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
    } catch (e) {
      // Ignore errors
    }
    
    localStorage.removeItem('ops_token');
    localStorage.removeItem('ops_employee');
    navigate('/ops/login');
  };

  const navItems = [
    { path: '/ops', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    { path: '/ops/clients', icon: Users, label: 'Clients' },
    { path: '/ops/onboarding', icon: ClipboardList, label: 'Onboarding Queue' },
    { path: '/ops/pending-changes', icon: FileCheck, label: 'Pending Changes' },
    { path: '/ops/link-agent', icon: Link2, label: 'Link Agent' },
    { path: '/ops/calls', icon: Phone, label: 'Calls' },
    { path: '/ops/sop', icon: FileText, label: 'SOP Guide' },
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  if (!employee) return null;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div className="w-64 bg-emerald-700 text-white flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-emerald-600">
          <h1 className="text-xl font-bold flex items-center gap-2">
            <CheckCircle className="w-6 h-6" />
            Calyro Ops
          </h1>
          <p className="text-emerald-200 text-sm mt-1">Onboarding Portal</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map(({ path, icon: Icon, label, exact }) => (
            <Link
              key={path}
              to={path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive(path, exact)
                  ? 'bg-emerald-800 text-white'
                  : 'text-emerald-100 hover:bg-emerald-600'
              }`}
            >
              <Icon className="w-5 h-5" />
              {label}
            </Link>
          ))}
        </nav>

        {/* User section */}
        <div className="p-4 border-t border-emerald-600">
          <div className="px-4 py-2 mb-2">
            <p className="font-medium text-white">{employee.name}</p>
            <p className="text-emerald-200 text-sm">{employee.email}</p>
            <p className="text-emerald-300 text-xs mt-1 capitalize">{employee.role?.replace('_', ' ')}</p>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 w-full text-left text-emerald-200 hover:text-white hover:bg-emerald-600 rounded-lg transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};
